import React from 'react';
import { connect } from 'react-redux';
import { ContentGroup } from 'ui';
import { additionalContentsSelector } from 'selectors/learn/contents';
import * as uiSelectors from 'selectors/learn/ui';
import { createCompoundId } from 'selectors/learn/helpers';
import ContentCard from '../../shared/LearnContentCard';

const AdditionalContents = ({ additionalContents, isOnlySection }) => (
  <ContentGroup
    className="LearnContentGroup"
    items={additionalContents}
    title={
      isOnlySection
        ? I18n.t('content.groups.my_learning_content')
        : I18n.t('content.groups.additional_learning_content')
    }
  >
    <ContentGroup.Items
      render={assignment => (
        <ContentCard key={createCompoundId(assignment)} {...assignment} />
      )}
    />
  </ContentGroup>
);

const mapStateToProps = state => ({
  additionalContents: additionalContentsSelector(state),
  isOnlySection: uiSelectors.hasOnlyAdditionalContentsSection(state),
});

export default connect(mapStateToProps)(AdditionalContents);
